module.exports = ".box-document {\n  border: 1px solid #dee2e6;\n  border-radius: 5px;\n  padding: 7px;\n  min-width: 140px; }\n\n.ngx-datatable .datatable-body .datatable-row-detail {\n  overflow-y: hidden;\n  overflow-x: hidden; }\n\n@media screen and (max-width: 800px) {\n  .desktop-hidden {\n    display: initial; }\n  .mobile-hidden {\n    display: none; } }\n\n@media screen and (min-width: 800px) {\n  .desktop-hidden {\n    display: none; }\n  .mobile-hidden {\n    display: initial; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/process-invoices/process-invoices.component.scss
// module id = ./src/app/pages/process-invoices/process-invoices.component.scss
// module chunks = main